import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/thumbs-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M466.3 286.7C475 271.8 480 256 480 236.8 480 192.8 442.8 151.3 394.2 151.3H357.7C362.6 138.5 366.6 123.1 366.6 104.7 366.6 31.9 328.9 0 271.3 0 209.7 0 213.2 94.9 199.5 108.6 176.8 131.3 149.9 175 130.8 192H32C14.3 192 0 206.3 0 224V464C0 481.7 14.3 496 32 496H96C110.9 496 123.4 485.8 127 472.1 171.5 473.1 202 512 304.8 512 312 512 320 512 327 512 404.1 512 439 472.6 439.9 416.7 453.3 398.2 460.2 373.5 457.3 349.7 467.1 331.2 470.9 309.3 466.3 286.7zM404.5 340.5C417.1 361.6 405.8 389.9 390.6 398.1 398.3 446.9 373 464 337.5 464H299.6C228 464 181.6 426.2 128 426.2V240H138.9C167.3 240 206.9 169.1 233.5 142.5 261.8 114.2 252.4 66.9 271.3 48 318.6 48 318.6 81 318.6 104.7 318.6 143.9 290.2 161.4 290.2 199.3H394.2C415.3 199.3 431.9 218.2 432 237.1 432.1 256 419.2 274.9 409.7 274.9 423.2 289.5 426.1 320.1 404.5 340.5zM88 432C88 445.3 77.3 456 64 456S40 445.3 40 432 50.7 408 64 408 88 418.7 88 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/thumbs-up.js
// module id = fa8O
// module chunks = 144